import { useEffect } from 'react';
import seoConfig from './seoConfig';

const SEO = ({
    title,
    description,
    keywords,
    page
}) => {
    useEffect(() => {
        const pageDefaults = page ? seoConfig[page] : {};

        const finalTitle = title || pageDefaults?.title;
        const finalDescription = description || pageDefaults?.description;
        const finalKeywords = keywords || pageDefaults?.keywords;

        // 1. Update Title
        if (finalTitle) {
            document.title = finalTitle;
        }

        // 2. Update Meta Tags with proper targeting
        const updateMetaTag = (name, content) => {
            if (!content) {
                return;
            }
            
            let element = document.querySelector(`meta[name="${name}"]`);
            
            if (!element) {
                element = document.createElement('meta');
                element.setAttribute('name', name);
                document.head.appendChild(element);
            }
            
            element.setAttribute('content', content);
        };

        // Update description and keywords
        if (finalDescription) {
            updateMetaTag('description', finalDescription);
        }
        
        if (finalKeywords) {
            updateMetaTag('keywords', finalKeywords);
        }

    }, [page, title, description, keywords]);

    return null;
};

export default SEO;